import React from 'react';
import './style.scss';

export default () => (
  <div className="loading">
    <div className="loadingSpinner" />
  </div>
);
